import { render, staticRenderFns } from "./pkg-item.vue?vue&type=template&id=f726f784&scoped=true"
import script from "./pkg-item.vue?vue&type=script&lang=js"
export * from "./pkg-item.vue?vue&type=script&lang=js"
import style0 from "./pkg-item.vue?vue&type=style&index=0&id=f726f784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f726f784",
  null
  
)

export default component.exports